import { app, pages } from '@vue3/configs'

const migratedPages = [
  {
    path: pages.registration,
    name: app.routerName.registration,
    redirect: '/registration/dealer-type',
    meta: {
      auth: true,
      notAllowedAfterRegistration: true,
      hideHeaderNavigation: true
    },
    children: [
      {
        path: pages.dealerType,
        name: app.routerName.dealerType,
        meta: {
          auth: true,
          notAllowedAfterRegistration: true,
          hideHeaderNavigation: true
        }
      },
      {
        path: pages.dealerInfo,
        name: app.routerName.dealerInfo,
        meta: {
          auth: true,
          notAllowedAfterRegistration: true,
          hideHeaderNavigation: true
        }
      },
      {
        path: pages.picInfo,
        name: app.routerName.picInfo,
        meta: {
          auth: true,
          notAllowedAfterRegistration: true,
          hideHeaderNavigation: true
        }
      },
      {
        path: pages.supportDocs,
        name: app.routerName.supportDocs,
        meta: {
          auth: true,
          notAllowedAfterRegistration: true,
          hideHeaderNavigation: true
        }
      },
      {
        path: pages.termsOfPayment,
        name: app.routerName.termsOfPayment,
        meta: {
          auth: true,
          notAllowedAfterRegistration: true,
          hideHeaderNavigation: true
        }
      }
    ]
  },
  {
    path: pages.termsAndCondition,
    name: app.routerName.termsAndCondition,
    meta: {
      auth: false,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.login,
    name: app.routerName.login,
    meta: {
      auth: false,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.signup,
    name: app.routerName.signup,
    meta: {
      auth: false,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.verifyEmail,
    name: app.routerName.verifyEmail,
    meta: {
      auth: true,
      notAllowedAfterRegistration: true,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.verifyEmailWithId,
    name: app.routerName.verifyEmailWithId,
    meta: {
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.rejectedPage,
    name: app.routerName.rejectedPage,
    meta: {
      auth: true,
      notAllowedAfterRegistration: true,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.resetPassword,
    name: app.routerName.resetPassword,
    children: [
      {
        path: ':id',
        name: app.routerName.resetPasswordWithId
      }
    ],
    meta: {
      auth: false,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.homePage,
    name: app.routerName.homePage,
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.orderList,
    name: app.routerName.orderList,
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.catalog,
    name: app.routerName.catalog,
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.landingPage,
    name: app.routerName.landingPage
  },
  {
    path: pages.rewards,
    name: app.routerName.rewards,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.rewards,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.rewardsDetail,
    name: app.routerName.rewardsDetail,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.rewards,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.orderDetail,
    name: app.routerName.orderDetail,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.orderDetail,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.notification,
    name: app.routerName.notification,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.orderDetail,
      hideHeaderNavigation: true
    }
  },
  {
    // temp path to support IOS older version
    path: '/order',
    name: 'orders',
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.checkout,
    name: app.routerName.checkout,
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true,
      headerTabGroup: app.routerName.catalog
    }
  },
  {
    path: pages.thankyouPage,
    name: app.routerName.thankyouPage,
    meta: {
      auth: true,
      notAllowedAfterRegistration: false,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.profile,
    name: app.routerName.profile,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.homePage,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.mission,
    name: app.routerName.mission,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.mission,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.missionDetail,
    name: app.routerName.missionDetail,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.mission,
      hideHeaderNavigation: true
    }
  },
  {
    path: pages.creditNote,
    name: app.routerName.creditNote,
    meta: {
      auth: true,
      headerTabGroup: app.routerName.creditNote,
      hideHeaderNavigation: true
    }
  }
]
export {
  migratedPages
}

